import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RevenueCalculator from './RevenueCalculator';
import { CartIcon } from '../../../components/CartIcon';
import { UserIcon } from '../../../components/UserIcon';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white/10 backdrop-blur-md'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/6b31031f-2a86-4533-82e4-f8093e93abdb.png" 
                alt="Airbnb Host Solutions" 
                className="h-10 sm:h-12 w-auto"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className={`font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'}`}>
                Home
              </Link>
              <Link to="/services" className={`font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'}`}>
                Services
              </Link>
              <Link to="/gallery" className={`font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'}`}>
                Gallery
              </Link>
              <Link to="/about" className={`font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'}`}>
                About
              </Link>
              <Link to="/contact" className={`font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'}`}>
                Contact
              </Link>
              <div className={scrolled ? 'text-gray-900' : 'text-white'}>
                <CartIcon />
              </div>
              <div className={scrolled ? 'text-gray-900' : 'text-white'}>
                <UserIcon />
              </div>
              <Link to="/contact" className="bg-[#FF6B6B] text-white px-6 py-2.5 rounded-lg hover:bg-[#ff5252] transition-all duration-300 font-semibold whitespace-nowrap cursor-pointer">
                Get Started
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden w-12 h-12 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-900' : 'text-white'}`}
            >
              <i className={`text-3xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center px-6">
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="absolute top-6 right-6 text-gray-900 w-12 h-12 flex items-center justify-center"
          >
            <i className="ri-close-line text-4xl"></i>
          </button>

          <nav className="flex flex-col items-center gap-6 text-xl w-full max-w-sm">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              Services
            </Link>
            <Link
              to="/gallery"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              Gallery
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              About
            </Link>
            <Link
              to="/social"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              Social
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-gray-900 hover:text-[#FF6B6B] transition-colors font-medium cursor-pointer w-full text-center py-3"
            >
              Contact
            </Link>
            <div className="flex items-center gap-4">
              <CartIcon />
              <UserIcon />
            </div>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-[#FF6B6B] text-white px-8 py-4 rounded-lg hover:bg-[#ff5252] transition-colors font-semibold whitespace-nowrap cursor-pointer w-full text-center text-lg mt-4"
            >
              Get Started
            </Link>
          </nav>
        </div>
      )}

      {/* Hero Content */}
      <div className="relative flex-1 flex items-end pb-12 sm:pb-16 md:pb-24">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/1d478d36fcff3a40f4ce889c9ce223b1.jpg"
            alt="Luxury Airbnb Interior"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center px-4 py-2 rounded-full border-2 border-white/80 backdrop-blur-sm mb-4 sm:mb-6">
              <span className="text-white font-medium text-sm sm:text-base">Transform Your Property</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Turn Your Home Into a Profitable Airbnb
            </h1>
            
            <p className="text-lg sm:text-xl text-white/95 mb-3 sm:mb-4 leading-relaxed font-medium">
              For busy homeowners, investors, and real estate professionals who want Airbnb and other online booking sites income without headaches:
            </p>
            
            <div className="bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-3 sm:py-4 rounded-xl mb-4 sm:mb-6 border-l-4 border-[#FF6B6B]">
              <p className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">
                We help homeowners earn 30% to 150% more income from Airbnb and other online booking sites
              </p>
            </div>
            
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 leading-relaxed">
              Complete consultation, setup, and management services to help homeowners create successful short-term rental properties. From code compliance to revenue optimization, we handle everything.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link 
                to="/contact" 
                className="bg-[#FF6B6B] text-white px-8 py-4 sm:py-5 rounded-lg font-semibold text-lg sm:text-xl hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap text-center"
              >
                Start Your Journey
              </Link>
              <button 
                onClick={() => setIsCalculatorOpen(true)}
                className="border-2 border-white text-white px-8 py-4 sm:py-5 rounded-lg font-semibold text-lg sm:text-xl hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                Calculate Revenue
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Revenue Calculator Modal */}
      <RevenueCalculator 
        isOpen={isCalculatorOpen} 
        onClose={() => setIsCalculatorOpen(false)} 
      />
    </div>
  );
}
